import { useState } from "react";

const menu = [
  {
    categorie: "☕ Cafés",
    items: [
      { nom: "Espresso", description: "Court et intense", prix: "500 FCFA" },
      { nom: "Americano", description: "Espresso allongé à l'eau chaude", prix: "700 FCFA" },
      { nom: "Cappuccino", description: "Espresso, lait chaud et mousse", prix: "900 FCFA" },
      { nom: "Café Latte", description: "Doux et crémeux", prix: "1 000 FCFA" },
      { nom: "Café Noisette", description: "Espresso avec une pointe de lait", prix: "700 FCFA" },
    ],
  },
  {
    categorie: "🧃 Boissons fraîches",
    items: [
      { nom: "Jus de bissap", description: "Hibiscus frais, légèrement sucré", prix: "600 FCFA" },
      { nom: "Jus de gingembre", description: "Vif et revigorant", prix: "600 FCFA" },
      { nom: "Limonade maison", description: "Citron, menthe, eau pétillante", prix: "700 FCFA" },
      { nom: "Eau minérale", description: "", prix: "300 FCFA" },
    ],
  },
  {
    categorie: "🥐 Snacks & Douceurs",
    items: [
      { nom: "Croissant beurre", description: "Feuilleté, doré à point", prix: "500 FCFA" },
      { nom: "Pain perdu", description: "Brioche, œuf, cannelle", prix: "800 FCFA" },
      { nom: "Cake chocolat", description: "Moelleux maison", prix: "700 FCFA" },
      { nom: "Sandwich poulet", description: "Pain maison, poulet grillé, crudités", prix: "1 200 FCFA" },
    ],
  },
  {
    categorie: "🍽️ Plats chauds",
    items: [
      { nom: "Riz sauce arachide", description: "Traditionnel et généreux", prix: "1 500 FCFA" },
      { nom: "Spaghetti bolognaise", description: "Sauce maison mijotée", prix: "1 500 FCFA" },
      { nom: "Omelette garnie", description: "Œufs, légumes, fromage", prix: "1 000 FCFA" },
    ],
  },
];

export default function CafeZamenoulli() {
  const [activeTab, setActiveTab] = useState(0);

  return (
    <div style={{ minHeight: "100vh", background: "var(--bg)" }}>

      {/* Hero */}
      <div style={{
        background: "linear-gradient(135deg, #f5f0e8 0%, #92400e 60%, #b45309 100%)",
        borderBottom: "4px solid #0d1117",
        padding: "60px 24px 48px",
        textAlign: "center",
      }}>
        <img
          src="/images/ZMNI.png"
          alt="Café Zamenoulli"
          style={{ width: 160, height: 160, objectFit: "contain", marginBottom: 20,
            filter: "drop-shadow(0 4px 16px rgba(0,0,0,0.4))" }}
          onError={(e) => { e.target.outerHTML = '<div style="font-size:4rem;margin-bottom:20px">☕</div>'; }}
        />
        <h1 style={{
          fontFamily: "var(--font-display)",
          color: "#fff",
          fontSize: "clamp(2rem, 6vw, 3.5rem)",
          textShadow: "3px 3px 0 rgba(0,0,0,0.3)",
          marginBottom: 8,
        }}>
          Café Zamenoulli
        </h1>
        <p style={{ color: "rgba(255,255,255,0.75)", fontSize: "1rem", fontWeight: 500 }}>
          ☕ Lomé, Togo — Ouvert tous les jours
        </p>
      </div>

      {/* Bande déco */}
      <div style={{
        height: 28,
        backgroundImage: `repeating-conic-gradient(#78350f 0% 25%, #fdf6ec 0% 50%)`,
        backgroundSize: "28px 28px",
        borderBottom: "3px solid #0d1117",
      }} />

      {/* Tabs catégories */}
      <div style={{
        display: "flex",
        overflowX: "auto",
        gap: 8,
        padding: "20px 24px",
        maxWidth: 860,
        margin: "0 auto",
      }}>
        {menu.map((cat, i) => (
          <button
            key={i}
            onClick={() => setActiveTab(i)}
            style={{
              whiteSpace: "nowrap",
              padding: "10px 20px",
              borderRadius: 30,
              border: "2px solid #78350f",
              background: activeTab === i ? "#78350f" : "transparent",
              color: activeTab === i ? "#fff" : "#78350f",
              fontWeight: 700,
              fontSize: "0.9rem",
              cursor: "pointer",
              transition: "all 0.15s",
            }}
          >
            {cat.categorie}
          </button>
        ))}
      </div>

      {/* Items du menu */}
      <div style={{ maxWidth: 860, margin: "0 auto", padding: "0 24px 60px" }}>
        <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
          {menu[activeTab].items.map((item, i) => (
            <div key={i} style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              background: "var(--bg-card, #fff)",
              border: "3px solid #0d1117",
              borderRadius: 16,
              padding: "18px 22px",
              boxShadow: "4px 4px 0 #0d1117",
            }}>
              <div>
                <div style={{ fontWeight: 800, fontSize: "1rem", color: "var(--ink, #0d1117)" }}>
                  {item.nom}
                </div>
                {item.description && (
                  <div style={{ fontSize: "0.85rem", color: "var(--ink-soft, #666)", marginTop: 3 }}>
                    {item.description}
                  </div>
                )}
              </div>
              <div style={{
                fontWeight: 800,
                fontSize: "1rem",
                color: "#78350f",
                whiteSpace: "nowrap",
                marginLeft: 16,
              }}>
                {item.prix}
              </div>
            </div>
          ))}
        </div>
      </div>

    </div>
  );
}